import type { Article } from '../models/articles';
import { type APIDefinition } from '../models/endpoints';
import type { IPage } from '../models/pages';

export const resolvePages = (
  articles: Array<Article>,
  apiDefinition?: APIDefinition
): Array<IPage> => {
  const pages: Array<IPage> = articles.map((article) => {
    const page: IPage = {
      // TODO (LTJ): should be able to simplify adapter
      id: article.id,
      label: article.label,
      article: article,
      children: article.children
        ? resolvePages(article.children, apiDefinition)
        : undefined
    };

    // No matching endpoint
    if (!article.endpoint || !apiDefinition) return page;

    const endpointPath = article.endpoint.path;

    // if there is no actually endpoint and we just want to show a badge
    if (!endpointPath || !article.endpoint.path) return page;

    const matchingPath = apiDefinition.paths[endpointPath];

    if (!matchingPath)
      console.error(
        `Unable to resolve article ${article.id} to endpoint ${endpointPath}`
      );
    const endpointMethod = article.endpoint.method;
    if (!matchingPath)
      console.error(
        `Unable to resolve article ${article.id} to endpoint ${article.endpoint}`
      );
    // Sometimes, there will be no matching endpoint, (for example in the case of the payouts-create endpoint)
    const matchingEndpoint = matchingPath?.[endpointMethod];

    return { ...page, endpoint: matchingEndpoint };
  });

  return pages;
};
